type Listener = () => void;

class AuthEventEmitter {
    private listeners: Listener[] = [];

    subscribe(listener: Listener) {
        this.listeners.push(listener);
        return () => {
            this.listeners = this.listeners.filter(l => l !== listener);
        };
    }

    emitLogout() {
        this.listeners.forEach(listener => listener());
    }
}

export const authEventEmitter = new AuthEventEmitter();
